module.exports = __webpack_public_path__ + "img/blueBack.d99f8dc1.svg";